import React from 'react';
import infoIcon from 'assets/info.svg';

const ProcessingBanner = () => (
  <div
    key="processing"
    className="text-sm bg-blue-10 flex flex-row items-center banner-container"
  >
    <p className="inline-flex items-center">
      <img
        alt="info"
        src={infoIcon}
        className="
          mr-2 h-25px w-25px
        "
      />{' '}
      Yield data is processing in the background. Refresh this page for
      confirmation once your loads are updated.
    </p>
  </div>
);

export default ProcessingBanner;
